import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    data() {
        return {
            packingTypeFully: 0,
            packingTypePartialy: 1,
            packingTypes: [
                { label: "Pakowanie częściowe", value: 1 },
                { label: "Pakowanie pełne", value: 0 },
            ]
        }
    },
    methods: {
        createPackingDefinition: async function (packingType) {
            return axios.post(`${serverUrl}Packing/Create`, packingType)
        },
        updatePackingDefinition: async function (packingType) {
            return axios.post(`${serverUrl}Packing/Update`, packingType)
        },
        deletePackingDefinition: async function (id) {
            return axios.post(`${serverUrl}Packing/Delete`, { id })
        },
        getPackingDefinitions: async function () {
            return axios.get(`${serverUrl}Packing/Get`)
        },
        getPackingDefinitionsByRecipeId: async function (recipeId, recipeType) {
            return axios.get(`${serverUrl}Packing/Get/${recipeType}/${recipeId}`)
        },
        packProduct: async function (productId, weight, packingDefinitionId, packingPlace, serialNumber, quantity, packingType) {
            return axios.post(`${serverUrl}Packing/PartialyPack`, {
                packingDefinitionId,
                productId,
                packingPlace,
                weight,
                serialNumber,
                quantity,
                packingType
            })
        },
        changePackedProductSerialNumber: async function (packedProductId, serialNumber) {
            return axios.post(`${serverUrl}Packing/ChangePackedProductSerialNumber`, {
                packedProductId,
                serialNumber
            })
        },
        searchPackedProductBySerialNumber: async function (text, isCoatingProduct, recipeId) {
            return axios.post(`${serverUrl}Packing/SearchPackedProductBySerialNumber`, {
                text,
                isCoatingProduct,
                recipeId
            })
        },
        meltDownProduct: async function (packedProductId, quantity) {
            return axios.post(`${serverUrl}Packing/MeltDownProduct`, {
                packedProductId,
                quantity
            })
        }
    },
};
